export const generatedSidecarValidationReport = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-sidecar-validation-gate",
  "operatingRule": "SPICE, Orekit, GMAT, Tudat, and OpenMDAO/Dymos outputs must enter through this gate before they can promote any trajectory, event-window, or optimization claim.",
  "contractHash": "sha256-7c4a24f9f81457204cb8d56bf3773f1b757ad96b02af5c4cedade5f84a61a81f",
  "submittedArtifactHash": "sha256-5c08b8fff4c392b9cc5e3774c3936833aa5ab9335910605e248b1e5d0d44f5ca",
  "contractCount": 5,
  "submittedArtifactCount": 5,
  "validationCount": 5,
  "promotedCount": 0,
  "blockedCount": 5,
  "averageFieldCoveragePercent": 19,
  "validations": [
    {
      "contractId": "spice-gf-event-window-v1",
      "artifactId": "spice-gf-mercury-contract-only",
      "tool": "NASA NAIF SPICE Geometry Finder",
      "domain": "ephemeris-event-windows",
      "scenarioId": "mercury-first",
      "fieldCoveragePercent": 25,
      "missingFields": [
        "toolVersion",
        "runAt",
        "kernelSet",
        "kernelHashes",
        "timeScale",
        "gfConstraint",
        "eventWindows",
        "uncertainty",
        "reproducibleCommand",
        "inputsHash",
        "outputsHash",
        "checksums"
      ],
      "sourceMismatch": [],
      "artifactState": "contract-only-no-runtime",
      "validationStatus": "blocked-no-runtime-artifact",
      "promotionAllowed": false,
      "blockers": [
        "Missing required field: toolVersion",
        "Missing required field: runAt",
        "Missing required field: kernelSet",
        "Missing required field: kernelHashes",
        "Missing required field: timeScale",
        "Missing required field: gfConstraint",
        "Missing required field: eventWindows",
        "Missing required field: uncertainty",
        "Missing required field: reproducibleCommand",
        "Missing required field: inputsHash",
        "Missing required field: outputsHash",
        "Missing required field: checksums",
        "Artifact is not runtime-generated.",
        "Validation status is not passed."
      ],
      "nextAction": "SPICE event windows can promote only when kernel hashes, time scale, GF constraints, generated windows, and checksum evidence are attached.",
      "validationHash": "sha256-5a5d1afbd6afdcb8c668ca1b8670ba6d3999df05afeaf37264c7fc15547bd46b"
    },
    {
      "contractId": "orekit-propagation-v1",
      "artifactId": "orekit-transfer-contract-only",
      "tool": "Orekit",
      "domain": "trajectory-propagation",
      "scenarioId": "hybrid",
      "fieldCoveragePercent": 18,
      "missingFields": [
        "toolVersion",
        "runAt",
        "dataContext",
        "frames",
        "timeScale",
        "forceModel",
        "events",
        "units",
        "uncertainty",
        "reproducibleCommand",
        "inputsHash",
        "outputsHash",
        "checksums",
        "independentComparison"
      ],
      "sourceMismatch": [],
      "artifactState": "contract-only-no-runtime",
      "validationStatus": "blocked-no-runtime-artifact",
      "promotionAllowed": false,
      "blockers": [
        "Missing required field: toolVersion",
        "Missing required field: runAt",
        "Missing required field: dataContext",
        "Missing required field: frames",
        "Missing required field: timeScale",
        "Missing required field: forceModel",
        "Missing required field: events",
        "Missing required field: units",
        "Missing required field: uncertainty",
        "Missing required field: reproducibleCommand",
        "Missing required field: inputsHash",
        "Missing required field: outputsHash",
        "Missing required field: checksums",
        "Missing required field: independentComparison",
        "Artifact is not runtime-generated.",
        "Validation status is not passed.",
        "Independent comparison has not passed."
      ],
      "nextAction": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
      "validationHash": "sha256-1119dbcfcde4d7e703ee1c811e1cd58b9aa73320206deafd84f805ea222b1f05"
    },
    {
      "contractId": "gmat-transfer-v1",
      "artifactId": "gmat-transfer-contract-only",
      "tool": "NASA GMAT",
      "domain": "mission-design-transfer",
      "scenarioId": "hybrid",
      "fieldCoveragePercent": 17,
      "missingFields": [
        "gmatVersion",
        "runAt",
        "scriptHash",
        "epoch",
        "forceModel",
        "optimizer",
        "trajectorySummary",
        "constraintSummary",
        "units",
        "uncertainty",
        "reproducibleCommand",
        "inputsHash",
        "outputsHash",
        "checksums",
        "independentComparison"
      ],
      "sourceMismatch": [],
      "artifactState": "contract-only-no-runtime",
      "validationStatus": "blocked-no-runtime-artifact",
      "promotionAllowed": false,
      "blockers": [
        "Missing required field: gmatVersion",
        "Missing required field: runAt",
        "Missing required field: scriptHash",
        "Missing required field: epoch",
        "Missing required field: forceModel",
        "Missing required field: optimizer",
        "Missing required field: trajectorySummary",
        "Missing required field: constraintSummary",
        "Missing required field: units",
        "Missing required field: uncertainty",
        "Missing required field: reproducibleCommand",
        "Missing required field: inputsHash",
        "Missing required field: outputsHash",
        "Missing required field: checksums",
        "Missing required field: independentComparison",
        "Artifact is not runtime-generated.",
        "Validation status is not passed.",
        "Independent comparison has not passed."
      ],
      "nextAction": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
      "validationHash": "sha256-fd51998cb94410d68529cf27b48595b365cf678cec24638b587a4010af17ca39"
    },
    {
      "contractId": "tudat-transfer-v1",
      "artifactId": "tudat-cross-check-contract-only",
      "tool": "Tudat",
      "domain": "cross-tool-trajectory-validation",
      "scenarioId": "asteroid-feedstock",
      "fieldCoveragePercent": 18,
      "missingFields": [
        "toolVersion",
        "runAt",
        "bodySettings",
        "integrator",
        "propagatorSettings",
        "trajectorySummary",
        "residualSummary",
        "units",
        "uncertainty",
        "reproducibleCommand",
        "inputsHash",
        "outputsHash",
        "checksums",
        "independentComparison"
      ],
      "sourceMismatch": [],
      "artifactState": "contract-only-no-runtime",
      "validationStatus": "blocked-no-runtime-artifact",
      "promotionAllowed": false,
      "blockers": [
        "Missing required field: toolVersion",
        "Missing required field: runAt",
        "Missing required field: bodySettings",
        "Missing required field: integrator",
        "Missing required field: propagatorSettings",
        "Missing required field: trajectorySummary",
        "Missing required field: residualSummary",
        "Missing required field: units",
        "Missing required field: uncertainty",
        "Missing required field: reproducibleCommand",
        "Missing required field: inputsHash",
        "Missing required field: outputsHash",
        "Missing required field: checksums",
        "Missing required field: independentComparison",
        "Artifact is not runtime-generated.",
        "Validation status is not passed.",
        "Independent comparison has not passed."
      ],
      "nextAction": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
      "validationHash": "sha256-3faae4035bb43c505a6a693654fb0e87bcf2ed98cc29d1239bcb45913474e22f"
    },
    {
      "contractId": "openmdao-dymos-optimization-v1",
      "artifactId": "dymos-optimization-contract-only",
      "tool": "OpenMDAO/Dymos",
      "domain": "optimization-and-sensitivity",
      "scenarioId": "moon-first",
      "fieldCoveragePercent": 17,
      "missingFields": [
        "toolVersion",
        "runAt",
        "problemHash",
        "transcription",
        "optimizer",
        "objective",
        "constraints",
        "sensitivitySummary",
        "units",
        "uncertainty",
        "reproducibleCommand",
        "inputsHash",
        "outputsHash",
        "checksums",
        "independentComparison"
      ],
      "sourceMismatch": [],
      "artifactState": "contract-only-no-runtime",
      "validationStatus": "blocked-no-runtime-artifact",
      "promotionAllowed": false,
      "blockers": [
        "Missing required field: toolVersion",
        "Missing required field: runAt",
        "Missing required field: problemHash",
        "Missing required field: transcription",
        "Missing required field: optimizer",
        "Missing required field: objective",
        "Missing required field: constraints",
        "Missing required field: sensitivitySummary",
        "Missing required field: units",
        "Missing required field: uncertainty",
        "Missing required field: reproducibleCommand",
        "Missing required field: inputsHash",
        "Missing required field: outputsHash",
        "Missing required field: checksums",
        "Missing required field: independentComparison",
        "Artifact is not runtime-generated.",
        "Validation status is not passed.",
        "Independent comparison has not passed."
      ],
      "nextAction": "Optimization outputs can influence recommendations only when objective, constraints, sensitivities, and reproducible run artifacts are attached.",
      "validationHash": "sha256-107495854516bbbfc541d914e716aa8aab5eb732afb8fc0b62098fe0ca36791b"
    }
  ],
  "promotionRule": "A sidecar artifact promotes only if it is runtime-generated, has all required fields, source ids match the contract, validation passed, and independent comparison passed where required.",
  "reportHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f"
}
;
